<template>
    <div class="pm ">
        <el-row class="video-tree flex" >

            <el-col :span="treespan"  v-show="isright"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
<!--                <left-tree @showData="showData"></left-tree>-->
                <left-tree @showData="showData"  ref="tree" :isuseSearch="false" :withPerson="true"></left-tree>
            </el-col>
            <el-col :span="rightspan"  style="height: 100%;min-width: 320px;width: 100%">
                <div class="p5">
                    <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>

                    <el-button class="marB10" @click="addNew" :class="baseerp+'btn'" size="mini":disabled="disadd">
                        新增
                    </el-button>
                    <el-button class="marB10" @click="deleteData " :class="baseerp+'btn'" size="mini" :disabled="disdel">
                        删除
                    </el-button>
                    <el-button class="marB10" @click="editRow" :class="baseerp+'btn'" size="mini" :disabled="disedit">
                        编辑
                    </el-button>
                    <el-button class="marB10" @click="savePositionSet" :class="baseerp+'btn'" size="mini" :disabled="dissave">
                        保存
                    </el-button>
                </div>
                <el-table
                        class="mrt10"
                        ref="table"
                        size="mini"
                        :height="tableHeight"
                        border
                        :data="tableData"
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                        :highlight-current-row="true"
                        @row-click="rowClick"
                        :row-class-name="rowClassName"
                        style="width: 100%">
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="center"
                            type="index"
                            width="50px">
                    </el-table-column>
                    <!--<el-table-column
                            align="center"
                            label="规则ID"
                            prop="i_id" show-overflow-tooltip>
                    </el-table-column>-->
                    <el-table-column
                            align="center"
                            label="开始时间"
                            prop="dt_start" show-overflow-tooltip>
                        <template slot-scope="scope" >
                            <el-date-picker
                                    v-if="scope.row.edit"
                                    v-model="scope.row.dt_start"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
                            <span v-else>{{scope.row.dt_start}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="结束时间"
                            prop="dt_end" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-date-picker
                                    v-if="scope.row.edit"
                                    v-model="scope.row.dt_end"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="选择日期">
                            </el-date-picker>
                            <span v-else>{{scope.row.dt_end}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="姓名"
                            prop="vc_uname_auth" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="类型"
                            prop="i_flag" show-overflow-tooltip>
                        <template slot-scope="scope" >
                            <el-select v-if="scope.row.edit" v-model="scope.row.i_flag" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in typeList"
                                        :key="item.i_id"
                                        :label="item.vc_name"
                                        :value="item.i_id">
                                </el-option>
                            </el-select>
                            <span v-else>{{scope.row.vc_flag}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="人员"
                        prop="vc_depts">
                    <template slot-scope="scope" >
                        <span  type="text" :class="'color409eff'" v-if="scope.row.edit" size="mini" @click="openTree(scope.row,6)">{{scope.row.vc_depts?scope.row.vc_depts:'选择人员'}}</span>
<!--                        <el-input  v-model="scope.row.vc_depts" v-if="scope.row.edit" @focus="openTree(6)"></el-input>-->
                        <span v-else>{{scope.row.vc_depts}}</span>
                    </template>
                </el-table-column><el-table-column
                        align="center"
                        label="品种"
                        prop="vc_products">
                    <template slot-scope="scope" >
                        <span  type="text" :class="'color409eff'" v-if="scope.row.edit" size="mini" @click="openTree(scope.row,3)">
                            {{scope.row.vc_products?scope.row.vc_products:'选择品种'}}
                        </span>
<!--                        <el-input  v-model="scope.row.vc_product" v-if="scope.row.edit" @focus="openTree(3)"></el-input>-->
                        <span v-else>{{scope.row.vc_products}}</span>
                    </template>
                </el-table-column>
                    <el-table-column
                            align="center"
                            :label="$t('form_company')"
                            prop="vc_companys">
                        <template slot-scope="scope" >
                            <span  type="text"  :class="'color409eff'" v-if="scope.row.edit" size="mini" @click="openTree(scope.row,4)">
                                {{scope.row.vc_companys?scope.row.vc_companys:'选择公司'}}
                            </span>
<!--                            <el-input  v-model="scope.row.vc_companys" v-if="scope.row.edit" @focus="openTree(4)"></el-input>-->
                            <span v-else>{{scope.row.vc_companys}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="业务类型"
                            prop="vc_ywtypes">
                        <template slot-scope="scope" >
                            <span  type="text"   :class="'color409eff'" v-if="scope.row.edit" size="mini" @click="openTree(scope.row,28)">
                                {{scope.row.vc_ywtypes?scope.row.vc_ywtypes:'选择业务类型'}}
                            </span>
<!--                            <el-input  v-model="scope.row.vc_ywtypes" v-if="scope.row.edit" @focus="openTree(28)"></el-input>-->
                            <span v-else>{{scope.row.vc_ywtypes}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="岗位信息"
                            prop="vc_positions">
                        <template slot-scope="scope" >
                            <span  type="text" :class="'color409eff'" v-if="scope.row.edit" size="mini" @click="openTransfer(scope.row,scope.$index,29)">
                                {{scope.row.vc_positions?scope.row.vc_positions:'选择岗位'}}
                            </span>
<!--                            <el-input  v-model="scope.row.vc_positions" v-if="scope.row.edit" @focus="openTransfer(scope.row,scope.$index,29)"></el-input>-->
                            <span v-else>{{scope.row.vc_positions}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="职级信息"
                            prop="vc_headships">
                        <template slot-scope="scope" >
                            <span  type="text"  :class="'color409eff'" v-if="scope.row.edit" size="mini" @click="openTransfer(scope.row,scope.$index,8)">
                                {{scope.row.vc_headships?scope.row.vc_headships:'选择职级'}}
                            </span>
                            <!--                            <el-input  v-model="scope.row.vc_headships" v-if="scope.row.edit" @focus="openTransfer(scope.row,scope.$index,8)"></el-input>-->
                            <span v-else>{{scope.row.vc_headships}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            align="center"
                            label="登记时间"
                            prop="dt_createtime" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="录入人"
                            prop="vc_lruname"
                            width="50px"   show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="用户状态"
                            prop="vc_ustate_auth" width="60px" show-overflow-tooltip>
                    </el-table-column>

                </el-table>
                <el-pagination
                        class="fr page"
                        style="margin-top: 10px;text-align: right"
                        background
                        layout="prev, pager, next"
                        @current-change="pageCurrentChange"
                        :current-page.sync="pageSize"
                        :total="pageTotal"
                        :page-size="pageCount">
                </el-pagination>
            </el-col>
        </el-row>
        <div :class="baseerp+'div'">
            <el-dialog :title="title"
                       width="80%"
                       class="minw840"
                       top="30px"
                       v-if="dialogTableVisibleW"
                       :visible.sync="dialogTableVisibleW"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <transfer-table :customertype="customertype" :transferData="transferData" :transferChooseData="transferChooseData" @getTransfer="getTransfer" @choosetran="choosetran" @close="transClose"></transfer-table>
            </el-dialog>
            <el-dialog :title="treetitle"
                       width="80%"
                       class="minw840"
                       top="30px"
                       v-if="dialogtreeVisibleW"
                       :visible.sync="dialogtreeVisibleW"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <transfer-tree @choosetree="choosetree" @close="treeClose" :datatype="customertype" :pid="chooseRow.i_id" :treeChoooseData="treeChoooseData"></transfer-tree>
                <!--               -->
            </el-dialog>
        </div>


    </div>

</template>

<script>
    import * as API from "./../api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    // import LeftTree from "../LeftTree";
    import LeftTree from "@/views/personInformation/LeftTree"//更换为人员信息公共部门树
    import TransferTable from "../compontents/TransferTable";
    import TransferTree from "../compontents/TransferTree";
    export default {
        name: "index",
        components: {TransferTable, LeftTree,TransferTree},
        data() {
            return {
                treetitle:'',
                isright:true,//树显示按钮
                disadd:false,
                dissave:false,
                disdel:false,
                disedit:false,
                customertype:'',
                title:'',
                // transferPage: { pageNo: 1, pageSize: 3, total: 6     },
                customerPage: { pageSize: 1, pageCount: 20, total: 0 ,search:''},
                dialogTableVisibleW:false,
                dialogtreeVisibleW:false,
                pageCount:10,
                pageSize:1,
                pageTotal:0,
                tableData:[],
                transferData:{},
                transferChooseData:[],
                treeChoooseData:[],
                tableHeight:0,//列表高度
                baseerp:'',
                treespan:4,
                rightspan:20,
                infomation:'',
                chooseRow:{},
                chooseIndex:0,
                accountType:[
                    {name:'操作',id:9},
                ],
                accountArea:[
                    {name:'国内',id:0},
                    {name:'国外',id:1},
                    {name:'全部',id:2},
                ],
                approvType:[],
                approvalPer:[],
                accountPz:[],
                accountGs:[],
                accountYw:[],
                accountKh:[],
                accountNkh:[],
                leaderList:[],
                typeList:[],

            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.baseerp=baseerp
            this.getAppFlowTypeList()
            this.getRightTypeList()
            this.$nextTick(()=>{
                this.onResize();

            })

        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            rowClassName({row,rowIndex}){
                row.index=rowIndex
                // console.log(row, row.index,'rowClassName')
            },
            rowClick(row){
                if (!this.chooseRow.edit) {

                    this.chooseRow = row
                    this.chooseIndex = row.index
                }
                // console.log(row, row.index,'row')
            },
            async getPositionSetList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let i_gid_auth=0,i_uid_auth=0;
                if (this.infomation&&this.infomation.nodeType==0){
                    i_uid_auth=this.infomation.value
                }else {
                    i_gid_auth=this.infomation.value

                }
                let param = {
                    i_mid: this.mid,
                    page_count:this.pageCount,
                    page_size:this.pageSize,
                    i_uid_auth:i_uid_auth,
                    i_gid_auth:i_gid_auth,

                };
                let res = await API.getPositionSetList(param);
                if (res.code == 1) {
                    this.tableData=res.data
                    this.pageTotal=res.count

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            addNew(){
                if (this.infomation&&this.infomation.nodeType==0){
                    this.disadd=true
                    this.disdel=true
                    this.disedit=true
                    this.tableData.unshift({
                        i_id:0,
                        vc_uname_auth:this.infomation.label,
                        dt_start:this.getDateYYYYMMdd(),
                        dt_end:'2099-12-31',
                        edit:true,
                        i_jljs:0,
                        i_flag:this.typeList[0].i_id,
                        vc_lruname:sessionStorage.getItem("lruname"),
                        dt_createtime:this.getDateYYYYMMdd(),
                        // vc_ustate_auth:this.infomation.vc_ustate_auth,
                        i_uid_auth:this.infomation.value,

                    })
                    this.chooseRow=this.tableData[0]
                    this.chooseIndex=0
                }else{
                    this.$message.warning('请选择具体人员')
                }

            },
            openTransfer(row,index,type){
                this.customertype=type
                // this.getAuthPSetSubList()
                if (type==8){
                    this.title='选择职级'
                    this.getHeadShipList();
                    this.transferChooseData=row.zj?row.zj:[]
                }else if (type==29){
                    this.title='选择岗位'
                    this.transferChooseData=row.gw?row.gw:[]
                    this.getPositionList();
                }
                this.dialogTableVisibleW=true
            },
            choosetran(val,type){
                //console.log(val,'this.tableData')
                // if (type==29){
                //     this.tableData[this.chooseIndex].gw=val
                // }
                if (type==8){
                    this.tableData[this.chooseIndex].zj=val
                }else if (type==29){
                    this.tableData[this.chooseIndex].gw=val
                }
                let text=val.filter(one=>one.flag==0||one.flag==1);
                if(text.length>0) {
                    if (type==8){
                        this.tableData[this.chooseIndex].vc_headships=text.map(one=>{
                            return one.label
                        }).join(';')
                    }else if (type==29){
                        this.tableData[this.chooseIndex].vc_positions=text.map(one=>{
                            return one.label
                        }).join(';')
                    }
                }else{
                    if (type==8){
                        this.tableData[this.chooseIndex].vc_headships=''
                    }else if (type==29){
                        this.tableData[this.chooseIndex].vc_positions=''
                    }
                }

                this.$set(this.tableData,this.chooseRow.index,this.chooseRow)

                this.transClose();
            },
            transClose(){
                this.dialogTableVisibleW=false
            },
            choosetree(val,type){
                if (type==3){
                    this.tableData[this.chooseIndex].pz=val
                    // console.log(this.tableData,'this.tableData[this.chooseIndex].vc_product')
                }else if (type==4){
                    this.tableData[this.chooseIndex].gs=val
                }else if (type==6){
                    this.tableData[this.chooseIndex].ry=val
                }else if (type==28){
                    this.tableData[this.chooseIndex].yw=val
                }
                let text=val.filter(one=>one.flag==0||one.flag==1);
                if(text.length>0){
                    if (type==3){
                        this.tableData[this.chooseIndex].vc_products=text.map(one=>{
                            return one.label
                        }).join(';')
                        // console.log(this.tableData,'this.tableData[this.chooseIndex].vc_product')
                    }else if (type==4){
                        this.tableData[this.chooseIndex].vc_companys=text.map(one=>{
                            return one.label
                        }).join(';')
                    }else if (type==6){
                        this.tableData[this.chooseIndex].vc_depts=text.map(one=>{
                            return one.label
                        }).join(';')
                    }else if (type==28){
                        this.tableData[this.chooseIndex].vc_ywtypes=text.map(one=>{
                            return one.label
                        }).join(';')
                    }
                }else{
                    if (type==3){
                        this.tableData[this.chooseIndex].vc_products=''
                        // console.log(this.tableData,'this.tableData[this.chooseIndex].vc_product')
                    }else if (type==4){
                        this.tableData[this.chooseIndex].vc_companys=''
                    }else if (type==6){
                        this.tableData[this.chooseIndex].vc_depts=''
                    }else if (type==28){
                        this.tableData[this.chooseIndex].vc_ywtypes=''
                    }
                }

                this.$set(this.tableData,this.chooseRow.index,this.chooseRow)

                this.treeClose();
            },
            openTree(row,type){
                this.customertype=type
                // this.getAuthPSetSubList()
                // console.log(row)
                if (type==3){
                    this.treetitle='选择产品'
                    this.treeChoooseData=row.pz?row.pz:[]
                }else if (type==4){
                    this.treetitle='选择公司'
                    this.treeChoooseData=row.gs?row.gs:[]
                }else if (type==6){
                    this.treetitle='选择部门/人员'
                    this.treeChoooseData=row.ry?row.ry:[]
                }else if (type==28){
                    this.treetitle='业务类型'
                    this.treeChoooseData=row.yw?row.yw:[]
                }
                //console.log(this.treeChoooseData,'openTree')
                this.dialogtreeVisibleW=true
            },
            treeClose(){
                this.dialogtreeVisibleW=false
            },
            editRow(){
                if(JSON.stringify(this.chooseRow)!=='{}'){
                    this.getAuthPSetSubList(3)
                    this.getAuthPSetSubList(4)
                    this.getAuthPSetSubList(6)
                    this.getAuthPSetSubList(8)
                    this.getAuthPSetSubList(15)
                    this.getAuthPSetSubList(28)
                    this.getAuthPSetSubList(29)
                    this.getAuthPSetSubList(32)
                    this.disadd=true
                    this.disdel=true
                    this.disedit=true
                    // this.tableData[this.chooseRow.index].edit=true;
                    // this.$set(this.tableData,this.chooseRow.index,this.chooseRow);
                    this.$set(this.tableData[this.chooseRow.index],'edit',true);

                }else{
                    this.$message.warning('请选择要编辑的数据')
                }
            },
            deleteData(){
                if(JSON.stringify(this.chooseRow)!=='{}') {
                    this.$confirm('是否删除该项', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        this.tableData.splice(this.chooseRow.index, 1)
                        this.delPositionSet();
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
                }else{
                    this.$message.warning('请选择要删除的数据')
                }
            },
            showData(val){
                this.infomation=val
                this.disadd=false
                this.disdel=false
                this.disedit=false
                this.chooseRow={}
                this.pageSize = 1
                this.getPositionSetList()
            },
            async getAuthPSetSubList(type){
                let param = {
                    i_mid: this.mid,
                   i_pid:this.chooseRow.i_id,
                    i_type:type
                    // i_type:6,
                };
                let res = await API.getAuthPSetSubList(param);
                if (res.code == 1) {
                    let list=[]
                    if (res.data.length>0){
                        list=res.data;
                        list.map(one=>{
                            one.label=one.vc_obj_name
                        })
                    }
                    // console.log(list)
                    if (type==3){
                        this.treetitle='选择产品'
                        this.chooseRow.pz=list
                    }else if (type==4){
                        this.treetitle='选择公司'
                        this.chooseRow.gs=list
                    }else if (type==6){
                        this.treetitle='选择部门/人员'
                        this.chooseRow.ry=list
                    }else if (type==28){
                        this.treetitle='业务类型'
                        this.chooseRow.yw=list
                    }else if (type==8){
                        this.title='选择职级'
                        this.chooseRow.zj=list
                    }else if (type==29){
                        this.title='选择岗位'
                        this.chooseRow.gw=list
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            getTransfer(pagesize,search){
                if (this.customertype==8){
                    this.getHeadShipList(pagesize,search);
                }else if (this.customertype==29){
                    this.getPositionList(pagesize,search);
                }
            },
            async getHeadShipList(pagesize=1,search=''){

                let param = {
                    i_mid: this.mid,
                    page_count:20,
                    page_size:pagesize,
                    vc_search: search,
                    i_uid_auth:this.chooseRow.i_uid_auth,

                    // i_type:6,
                };
                let res = await API.getHeadShipList(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                rightCheck:false,

                                // i_pid:one.i_pid,
                                vc_ustate_auth:one.vc_ustate_auth,
                            };
                            list.push(hash);
                        })
                    }
                    this.transferData={
                        list:list,
                        total:res.count,
                        pid:this.chooseRow.i_id
                    }
                    // console.log(this.transferData,'this.transferData')
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getYwTypeList(pagesize=1,search=''){

                let param = {
                    i_mid: this.mid,
                    page_count:20,
                    page_size:pagesize,
                    vc_search: search,
                    // i_uid_auth:this.infomation.value,

                    // i_type:6,
                };
                let res = await API.getYwTypeList(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                i_obj:one.i_id,
                                rightCheck:false,
                                i_state:one.i_state,
                                // i_pid:one.i_pid,
                                vc_ustate_auth:one.vc_ustate_auth,
                            };
                            list.push(hash);
                        })
                    }
                    this.transferData={
                        list:list,
                        total:res.count,
                        pid:this.chooseRow.i_id
                    }
                    //console.log(this.transferData,'this.transferData')
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getPositionList(pagesize=1,search=''){

                let param = {
                    i_mid: this.mid,
                    page_count:20,
                    page_size:pagesize,
                    vc_search: search,
                    i_uid_auth:this.chooseRow.i_uid_auth,

                    // i_type:6,
                };
                let res = await API.getPositionList(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                rightCheck:false,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                // i_pid:one.i_pid,
                                vc_ustate_auth:one.vc_ustate_auth,
                            };
                            list.push(hash);
                        })
                    }
                    this.transferData={
                        list:list,
                        total:res.count,
                        pid:this.chooseRow.i_id
                    }
                    // console.log(this.transferData,'this.transferData')
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getAppFlowTypeList(pagesize=1,search=''){

                let param = {
                    i_mid: this.mid,
                    page_count:10,
                    page_size:pagesize,
                    vc_search: search,
                    i_uid_auth:this.chooseRow.i_uid_auth,

                    // i_type:6,
                };
                let res = await API.getAppFlowTypeList(param);
                if (res.code == 1) {
                        this.approvType=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getRightTypeList(){
                let param = {
                    i_mid: this.mid,
                    i_type:2,
                };
                let res = await API.getRightTypeList(param);
                if (res.code == 1) {
                    this.typeList=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async savePositionSet(){
                if(JSON.stringify(this.chooseRow)!=='{}'&&this.chooseRow.edit==true) {

                    let arr = [];
                    let obj = {
                        i_id: this.chooseRow.i_id,
                        i_pid: this.chooseRow.i_pid,
                        i_obj: '',
                        i_type: 6,
                        i_state: '',
                    };
                    arr = this.chooseRow.ry && this.chooseRow.ry.length != 0 ? arr.concat(this.chooseRow.ry) : arr
                    arr = this.chooseRow.gs && this.chooseRow.gs.length != 0 ? arr.concat(this.chooseRow.gs) : arr
                    arr = this.chooseRow.zj && this.chooseRow.zj.length != 0 ? arr.concat(this.chooseRow.zj) : arr
                    arr = this.chooseRow.yw && this.chooseRow.yw.length != 0 ? arr.concat(this.chooseRow.yw) : arr
                    arr = this.chooseRow.gw && this.chooseRow.gw.length != 0 ? arr.concat(this.chooseRow.gw) : arr
                    arr = this.chooseRow.pz && this.chooseRow.pz.length != 0 ? arr.concat(this.chooseRow.pz) : arr
                    // this.chooseRow.sublis= Array.from(new Set([...this.chooseRow.ry, ...this.chooseRow.gs, ...this.chooseRow.kh,...this.chooseRow.nokh, ...this.chooseRow.pz]));
                    //console.log(this.chooseRow, 'chooseRow')
                    let param = {
                        i_mid: this.mid,
                        i_uid_auth: this.chooseRow.i_uid_auth,
                        vc_uname_auth: this.infomation.label,
                        // vc_ustate_auth: this.infomation.vc_ustate_auth,
                        i_id: this.chooseRow.i_id,
                        dt_start: this.chooseRow.dt_start,
                        dt_end: this.chooseRow.dt_end,
                        i_flag: this.chooseRow.i_flag,
                        i_isexport: this.chooseRow.i_isexport,
                        i_sptype: this.chooseRow.i_sptype,
                        dt_createtime: this.chooseRow.dt_createtime,
                        lururen: this.chooseRow.vc_lruname,
                        sublist: arr,
                        // i_type:6,
                    };
                    let res = await API.savePositionSet(param);
                    if (res.code == 1) {
                        this.disadd = false
                        this.disdel = false
                        this.disedit = false
                        this.pageSize = 1
                        this.getPositionSetList()
                        this.chooseRow = {}
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            async delPositionSet(){
                this.dissave=true
                let i_idList=[],idinfo={i_id:this.chooseRow.i_id,i_uid_auth:this.chooseRow.i_uid_auth}
                i_idList.push(idinfo)
                let param = {
                    i_mid: this.mid,
                    idList:i_idList,

                    // i_type:6,
                };
                let res = await API.delPositionSet(param);
                if (res.code == 1) {
                    this.disadd=false
                    this.disdel=false
                    this.disedit=false
                    this.dissave=false
                    this.chooseRow = {}
                    this.pageSize = 1
                    this.getPositionSetList()
                } else if (res.code == -2) {
                    this.dissave=false
                    this.disadd=false
                    this.disdel=false
                    this.disedit=false
                    this.chooseRow = {}

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.dissave=false
                    this.disadd=false
                    this.disdel=false
                    this.disedit=false
                    this.chooseRow = {}
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val) {
                this.pageSize=val;
                this.getPositionSetList()
            },
            getDateYYYYMMdd(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
        },
    }
</script>

<style lang="scss" scoped>

    .flex{
        display: flex;
    }
    .p5{
        padding: 5px 0;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }

    .color409eff{
        color: var(--light) !important;
        display: inline-block;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 840px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-table .el-button--text{
            color: #333;
        }
    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
</style>